import { render, staticRenderFns } from "./EMelderComponentRisikoSearch.vue?vue&type=template&id=8069df84&scoped=true"
import script from "./EMelderComponentRisikoSearch.vue?vue&type=script&lang=js"
export * from "./EMelderComponentRisikoSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8069df84",
  null
  
)

export default component.exports